import { HTMLMotionProps, motion, AnimatePresence } from 'framer-motion';
// eslint-disable-next-line
import React, { PropsWithChildren } from 'react';

import { VARIANTS } from 'utils/motion-variants';
import { mergeAnimationProps } from '../utils';

type Props = {
  isVisible?: boolean;
  animatePresence?: boolean;
} & PropsWithChildren<HTMLMotionProps<'div'>>;

function OpacityAnimation({
  isVisible = true,
  animatePresence = true,
  initial,
  animate,
  transition,
  exit,
  children,
  ...rest
}: Props) {
  const showContent = () =>
    isVisible && (
      <motion.div
        initial={mergeAnimationProps(initial, VARIANTS.initial.hiddenOpacity)}
        animate={mergeAnimationProps(animate, VARIANTS.animate.visibleOpacity)}
        transition={mergeAnimationProps(
          transition,
          VARIANTS.transition.default
        )}
        exit={mergeAnimationProps(exit, VARIANTS.exit.opacity)}
        {...rest}
      >
        {children}
      </motion.div>
    );

  if (animatePresence) {
    return <AnimatePresence>{showContent()}</AnimatePresence>;
  }

  return <>{showContent()}</>;
}
export default OpacityAnimation;
